import { FaDiscord, FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const ContactData = {
  phone: "+91 9515643851",
  email: "talakolavijaykumar@gmail.com",
  address: "Guntur , Andhra Pradesh , India",
  links: [
    {
      url: "https://github.com/VijayKumarReddyTalakola",
      icon: FaGithub,
    },
    {
      url: "https://www.linkedin.com/in/vijay-talakola",
      icon: FaLinkedin,
    },
    {
      url: "https://discordapp.com/users/talakolavijay",
      icon: FaDiscord,
    },
    {
      url: "https://www.instagram.com/vijay_talakola",
      icon: FaInstagram,
    },
    {
      url: "https://twitter.com/talakolavijay",
      icon: FaXTwitter,
    },
  ],
};

export default ContactData;
